<!-- version 2021/05/20 -->
<template>
    <a :href='link' target='_blank'>
      {{ text }}
      <i class='fa fa-external-link'/>
    </a>
</template>

<script>
    export default {
        props: {
            text: String,
            link: String
        }
    }
</script>

<style lang="sass" scoped>
    a
        color: #28c3cd
</style>
